<template>
  <vi-tooltip
    data-testid="destination-type-selector-tab-index-6qHS4T"
    :disabled="isClosedCta ? true : !disabledText"
    placement="top"
    effect="light"
    :content="disabledText"
    :hide-delay="400"
  >
    <div
      data-testid="destination-type-selector-tab-index-kan5En"
      :class="[
        $style.typeSelectorWrap,
        active ? $style.active : '',
        isClosedCta ? $style.disabledSelector : '',
        disabled || isClosedCta ? $style.disabled : '',
      ]"
      @click="handleClick"
    >
      <div :class="$style.contentWrap">
        <slot />
      </div>
    </div>
  </vi-tooltip>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
const name = 'ttam-creative-destination-type-selector-tab';

export default defineComponent({
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // CTA是否是关闭状态
    isClosedCta: {
      type: Boolean,
      default: false,
    },
    disabledText: {
      type: String,
      default: '',
      // default: i18n.t('creative_destination_cta_disable'), // 因为这个文案翻译还未完成，PM要求暂时隐藏这个文案，等翻译完成后再展示
    },
  },
  setup(props, ctx) {
    const handleClick = () => {
      if (props.disabled) {
        return;
      }
      ctx.emit('change');
    };

    return {
      name,
      handleClick,
    };
  },
});
</script>

<style lang="scss" module>
.typeSelectorWrap {
  display: flex;
  box-sizing: border-box;
  border-radius: 4px;
  background: $--color-group3-9;
  outline: 1px solid $--color-group3-9;
  cursor: pointer;
  height: 100%;

  &:not(.disabled) {
    &:hover {
      background: $--color-group3-8;
      .contentWrap {
        border-color: $--color-group3-8;
      }
    }
  }

  .contentWrap {
    padding: 12px 16px;
    border-left: 1px solid $--color-group3-9;
    border-radius: 4px;
    overflow: hidden;
  }

  &.active {
    background: white;
    outline-color: $--color-group1-5;
    :global {
      .selectorSubtitle {
        color: $--color-group1-5;
      }
    }

    .contentWrap {
      color: $--color-group1-5;
      border-left-color: $--color-group1-5;
      box-shadow: inset 4px 0px 0px $--color-group1-5;
    }
    &:focus {
      outline-width: 1px;
    }
  }

  &.disabledSelector {
    background: $--color-group3-9;
    outline-color: $--color-group3-9;
    opacity: 0.4;

    .contentWrap {
      color: $--color-group3-2;
      border-left-color: $--color-group3-9;
      box-shadow: inset 4px 0px 0px $--color-group3-9;
    }
  }

  &.disabled {
    cursor: not-allowed;
    user-select: none;

    &:hover {
      box-shadow: none;
    }
    &:focus {
      outline-width: 1px;
    }
    :global {
      .selectorSubtitle {
        color: $--color-group2-1;
      }
    }
  }

  &.active {
    cursor: default;
  }
}
</style>
